// extracted by mini-css-extract-plugin
export default {"infoSection":"AboutInfo_infoSection__iDObv","contactInfo":"AboutInfo_contactInfo__VGSNp","socialIcons":"AboutInfo_socialIcons__ytzIV","welcome":"AboutInfo_welcome__ISKNo"};